<template>
    <v-layout>
        <v-flex xs12>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                data-vv-scope="confirmUpdate"
                @submit.prevent="validateBeforeSubmit('confirmUpdate')"
            >
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-switch
                            :persistent-hint="true"
                            hint="Note: This will overwrite the 'GPS Enabled' status of all the selected Trains"
                            false-value="0" true-value="1"
                            v-model="gpsEnabled" :value="1" label="Is GPS Enabled?"></v-switch>
                    </v-flex>
                    <v-flex xs12 class="mt-4">
                        <v-layout justify-end>
                            <v-btn type="submit"
                                   :disabled="!valid || loading.submit"
                                   color="primary"
                                   :loading="loading.submit"
                            >
                                Submit
                            </v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-dialog
                v-model="confirmationDialog"
                persistent
                max-width="600"
            >
                <v-card>
                    <v-card-title class="title">Are you sure you want to update {{ totalRecords }} records
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="green darken-1 white--text"
                            @click="updateTrains"
                            :loading="loading.submit"
                            :disabled="loading.submit"
                        >
                            Approve
                        </v-btn>
                        <v-btn
                            color="red darken-1 white--text"
                            @click="cancelUpdate"
                            :loading="loading.submit"
                            :disabled="loading.submit"
                        >
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: "TrainForm",
    props: {
        checkedRows: {
            type: Array,
            default: function () {
                return []
            }
        },
        unCheckedRows: {
            type: Array,
            default: function () {
                return []
            }
        },
        filters: {
            type: Object,
            default: function () {
                return {
                    name: '',
                    speed: null,
                    lines: [],
                }
            }
        },
        allSelected: {
            type: Boolean,
            default: false
        },
        totalRecords: {
            type: Number,
            default: 0
        },
    },
    methods: {
        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        confirmUpdate() {
            this.confirmationDialog = true
        },
        cancelUpdate() {
            this.confirmationDialog = false
        },
        updateTrains() {
            this.loading.submit = true
            axios.post(`${process.env.VUE_APP_API_URL}/api/v1/local-trains/multiple`, {
                checked_rows: this.checkedRows,
                unchecked_rows: this.unCheckedRows,
                filters: this.filters,
                all_selected: this.allSelected,
                gps_enabled: this.gpsEnabled
            }, {headers: this.$headers})
                .then((response) => {
                    if (response.data.status == 1) {
                        this.$emit('success')
                    }
                })
                .finally(() => {
                    this.loading.submit = false
                })
        },
    },
    data: function () {
        return {
            valid: false,
            confirmationDialog: false,
            loading: {
                submit: false
            },
            gpsEnabled: false
        }
    }
}
</script>
